import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 400 - 显示图片事件
 */
import EventFilter from './EventFilter'

export default class EventPicShow extends EventBase {
  /**
   * 显示图片事件构造函数
   */
  constructor() {
    super()
    this.Parameter = [
      '0',
      '',
      '0',
      '0',
      '0',
      '100',
      '100',
      '255',
      '0',
      '0',
      '2',
      '0',
      '0',
    ]
  }


  /**
   * 事件ID
   */
  Code = EventID.PicShow
  // #region 事件内关键属性参数
  /**
   * 图片ID
   */
  get PicId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set PicId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 图片相对路径
   */
  get PicPath() {
    return this.Parameter?.[1] || ''
  }
  set PicPath(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /// <summary>
  /// 图片坐标是否为橙光数值指定
  /// 0为非数值指定（常量），1为是橙光动态数值指定
  /// </summary>
  get IsAssigned() {
    return this.Parameter?.[2] == '1'
  }
  set IsAssigned(value) {
    this.Parameter && (this.Parameter[2] = value ? '1' : '0')
  }
  /**
   * X坐标
   */
  get X() {
    return parseInt(this.Parameter?.[3] || '')
  }
  set X(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }
  /**
   * Y坐标
   */
  get Y() {
    return parseInt(this.Parameter?.[4] || '')
  }
  set Y(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }
  /**
   * X轴缩放率
   */
  get ZoomX() {
    return Number(this.Parameter?.[5] ?? '0')
  }
  set ZoomX(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }

  /**
   * Y轴缩放率
   */
  get ZoomY() {
    return Number(this.Parameter?.[6] ?? '0')
  }
  set ZoomY(value) {
    this.Parameter && (this.Parameter[6] = value.toString())
  }

  /**
   * 图片透明度，0~255
   */
  get Opacity() {
    return parseInt(this.Parameter?.[7] ?? '')
  }
  set Opacity(value) {
    this.Parameter && (this.Parameter[7] = value.toString())
  }

  /// <summary>
  /// 是否使用了镜像功能
  /// 0否1是
  /// </summary>
  get IsMirror() {
    return this.Parameter?.[8] == '1'
  }
  set IsMirror(value) {
    this.Parameter && (this.Parameter[8] = value ? '1' : '0')
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[9] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[9] = value.toString())
  }

  /// <summary>
  /// 是否素材来源自云网盘
  /// 2是（云网盘公有区资源）
  /// </summary>
  get IsPublicwebdisk() {
    return this.Parameter?.[10] == '2'
  }
  set IsPublicwebdisk(value) {
    this.Parameter && (this.Parameter[10] = value ? '2' : '1')
  }

  /// <summary>
  /// 图片名称是否为橙光字符串指定
  /// 0为是非字符串指定（固定图片），1为是橙光动态字符串指定
  /// </summary>
  get IsUserStrAssigned() {
    return this.Parameter?.[11] == '1'
  }
  set IsUserStrAssigned(value) {
    this.Parameter && (this.Parameter[11] = value ? '1' : '0')
  }

  /// <summary>
  /// 指定的为橙光字符串索引
  /// 如果不存在则返回0
  /// </summary>
  get UserAssignedStrID() {
    return this.IsUserStrAssigned ? parseInt(this.Parameter?.[12] ?? '') : 0
  }
  set UserAssignedStrID(value) {
    this.Parameter &&
      (this.Parameter[12] = this.IsUserStrAssigned ? value + '' : '0')
  }

  get Filter() {
    return new EventFilter(this.Parameter ?? [], 13)
  }
  set Filter(value) {
    this.Parameter = value.ToParameter(this.Parameter ?? [], 13)
  }

  // #endregion

  /**
   * 获得该事件在事件列表的描述信息（对于显示图片而言，是第9项）
   */
  /// <returns>事件描述信息</returns>
  /**
   * 初级模式组合参数 Add by Guo Yang 20170415
   */
  public easyCombinPar = ''
  /**
   * 初级模式生成事件辅助参数
   * 0:PicId
   * 1:图片路径
   * 2:启始X坐标
   * 3:启始Y坐标
   * 4:X方向缩放
   * 5:Y方向缩放
   * 6:启始不透明度
   * 7:X终止坐标
   * 8:Y终止坐标
   * 9:启始缩放
   * 10:终止缩放
   * 11:终止不透明度
   * 12:等待总帧数
   * 13:是否镜像（0是，1否）
   */
  get EasyCombinPar() {
    return this.easyCombinPar
  }
  set EasyCombinPar(value) {
    this.easyCombinPar = value
  }
}
